<template>
  <div>
    <confirm-paper></confirm-paper>
  </div>
</template>

<script>
  import ConfirmPaper from './product/orderMenu/ConfirmPaper.vue'
  import axios from 'axios/dist/axios.min'

  export default {
    name: 'order',
    components: {ConfirmPaper},
    async created(){
      const response = await axios.get('/carts/' + this.$route.params.id + '.json');
      const json = JSON.parse(response.data.cart.json);
      this.$store.commit('resetStockCart');
      this.$store.commit('resetCart');
      if (json.json.stock_cart) {
        this.$store.commit('setStockCart', json.json.stock_cart);
        this.$store.commit('setOrder', json.json.order);
      } else {
        this.$store.commit('setCartJson', {
          // number: response.data.cart.code,
          // json: json,
          category: json.json.category,
          figure: json.json.figure,
          design: json.json.design,
          parts: json.json.parts,
          letters: json.json.letters,
          packs: json.json.packs,
          number: response.data.cart.code,
          order: json.json.order,
        });
      }
    }
  }
</script>
